<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
}

</script>
<style lang="scss">
@import "~bootstrap/dist/css/bootstrap.css";
body {
  font-family: Geneva, "Helvetica Neue", Helvetica, Arial, "Microsoft JhengHei", sans-serif;
  background: #F2F2F2;
  color: #3A484F;
}

</style>



// WEBPACK FOOTER //
// App.vue?e6ee59d2